import "@/global.scss";
import "@/global";
import React from "react";
import PageView from "@/pages";
import GlobalTransition from "@/components/GlobalTransition";
import { ConfigProvider } from "antd-mobile";
import zhCN from "antd-mobile/es/locales/zh-CN";
/**
 * @see https://mobile.ant.design/zh/guide/css-variables/#css-变量自动降级
 */
import "antd-mobile/bundle/css-vars-patch.css";


interface IAppProps {}
const App: React.FC<IAppProps> = () => {
  return (
    <React.Suspense fallback={<GlobalTransition />}>
      {/* @ts-ignore */}
        <ConfigProvider locale={zhCN}>
          <PageView></PageView>
        </ConfigProvider>
    </React.Suspense>
  );
};

export default App;
